// This Component is use to add Loader in any Page as well as in any Ajax request.
// By Default This Loader works for Web-Page and when we pass the props {For='AJAX'}, Then it is for Ajax request.
// By Default Loader17 will show in Page, If we pass props {UniqueId='2'}, Then Loader2 will show in Page.
// Examples :- <Loader/>, <Loader UniqueId={'2'}/>, <Loader For={'AJAX'}/>, <Loader For={'AJAX'} UniqueId={'2'}/>

import React from "react";
import "./Loader.css"

export default (props) => {
    let For = props.For !== undefined && props.For === 'AJAX' ? 'AJAX' : 'WEB-PAGE'
    let UniqueId = props.UniqueId !== undefined ? props.UniqueId : '17'
    if (For === 'WEB-PAGE') {
        return (
            <div className="d-flex justify-content-center align-items-center min-vh-100 loader-background-color">
                <img src={process.env.PUBLIC_URL + `Images/Loader${UniqueId}.gif`}  className="ClientPortalLoader" alt="LOADING.."/>
            </div>
        )
    } else {
        return (
            <div className="d-flex justify-content-center">
                <img src={process.env.PUBLIC_URL + `Images/Loader${UniqueId}.gif`} className="ClientPortalLoader" alt="LOADING.."/>
            </div>
        )
    }
}